import { useMemo } from 'react';
import { EditOutlined as EditOutlinedIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import CDButton from '../../../components/CDButton';

import { Campaign, CampaignChangeRequest } from '../../../types/Campaign';
import { useCampaignChange } from '../../../hooks/Models/Campaign/CampaignChange';
import {
    CAMPAIGN_CHANGE_GRACE_PERIOD_DAYS,
    useCampaignChangeGracePeriod,
} from '../../../hooks/Models/Campaign/CampaignChangeGracePeriod';

interface CampaignModifyButtonProps {
    campaign: Campaign;
    campaignChangeRequest: CampaignChangeRequest | null;
}

const CampaignModifyButton = ({
    campaign,
    campaignChangeRequest,
}: CampaignModifyButtonProps): React.JSX.Element | null => {
    const navigate = useNavigate();

    const { isCampaignChangeable } = useCampaignChange({ campaign, campaignChangeRequest });
    const { hasCampaignChangeGracePeriodExpired } = useCampaignChangeGracePeriod({ campaign });

    const isDisabled = useMemo((): boolean => {
        return isCampaignChangeable === false;
    }, [isCampaignChangeable]);

    const tooltip = useMemo((): string => {
        if (hasCampaignChangeGracePeriodExpired) {
            return `You cannot Modify a campaign ${CAMPAIGN_CHANGE_GRACE_PERIOD_DAYS} days after it has ended. If you intend to restart this campaign please create a new one.`;
        }

        if (campaignChangeRequest !== null && campaignChangeRequest.status === 'Pending') {
            return 'You can not modify a campaign that already has a pending change request.';
        }

        return 'Request Campaign Changes';
    }, [campaignChangeRequest, hasCampaignChangeGracePeriodExpired]);

    return (
        <>
            <CDButton
                loadingPosition="start"
                tooltip={tooltip}
                disabled={isDisabled}
                startIcon={<EditOutlinedIcon />}
                onClick={() => {
                    navigate('/campaign/v2/' + campaign.id, {
                        state: {
                            // isChangeRequest: true,
                            // campaignId: campaign.id,
                            // from: 'overview',
                        },
                    });
                }}
            >
                Modify
            </CDButton>
        </>
    );
};

export type { CampaignModifyButtonProps };
export default CampaignModifyButton;
